import { MrbBaseRouteStore } from "mrb/core";
import { CertifiedModeService } from "common/services";

class AdminCertifiedModeListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(CertifiedModeService);
    }

    async findCertifiedModes(params) {
        const response = await this.service.find(params);
        return response.data;
    }

    async deleteCertifiedMode(resource) {
        const response = await this.service.delete(resource);
        return response.data;
    }
}

export default AdminCertifiedModeListRouteStore;
